import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Frigates from "@/pages/Frigates";
import Directory from "@/pages/Directory";
import Library from "@/pages/Library";
import ProgressMap from "@/pages/ProgressMap";
import Feedback from "@/pages/Feedback";
import Invite from "@/pages/Invite";
import Profile from "@/pages/Profile";
import Command from "@/pages/Command";
import Island from "@/pages/Island";
import HappyHour from "@/pages/HappyHour";
import Office from "@/pages/Office";
import Messages from "@/pages/Messages";
import Join from "@/pages/Join";
import Signup from "@/pages/Signup";
import Oracle from "@/pages/Oracle";
import Fliers from "@/pages/Fliers";
import Population from "@/pages/Population";
import Privacy from "@/pages/Privacy";
import Support from "@/pages/Support";
import Leave from "@/pages/Leave";

const member = (el) => (
  <ProtectedRoute>
    <AppShell>{el}</AppShell>
  </ProtectedRoute>
);
const officer = (el) => (
  <ProtectedRoute min="officer">
    <AppShell>{el}</AppShell>
  </ProtectedRoute>
);

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/join/:code" element={<Join />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/leave" element={<Leave />} />
            <Route path="/dashboard" element={member(<Dashboard />)} />
            <Route path="/oracle" element={member(<ProtectedRoute min="member"><Oracle /></ProtectedRoute>)} />
            <Route path="/fliers" element={member(<ProtectedRoute min="member"><Fliers /></ProtectedRoute>)} />
            <Route path="/population" element={member(<ProtectedRoute min="member"><Population /></ProtectedRoute>)} />
            <Route path="/island" element={member(<Island />)} />
            <Route path="/messages" element={member(<Messages />)} />
            <Route path="/happy-hour" element={member(<HappyHour />)} />
            <Route path="/office" element={member(<ProtectedRoute min="member"><Office /></ProtectedRoute>)} />
            <Route path="/frigates" element={member(<ProtectedRoute min="member"><Frigates /></ProtectedRoute>)} />
            <Route path="/directory" element={member(<ProtectedRoute min="member"><Directory /></ProtectedRoute>)} />
            <Route path="/library" element={member(<ProtectedRoute min="member"><Library /></ProtectedRoute>)} />
            <Route path="/progress" element={member(<ProtectedRoute min="member"><ProgressMap /></ProtectedRoute>)} />
            <Route path="/feedback" element={member(<ProtectedRoute min="member"><Feedback /></ProtectedRoute>)} />
            <Route path="/profile" element={member(<Profile />)} />
            <Route path="/invite" element={officer(<Invite />)} />
            <Route path="/command" element={officer(<Command />)} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
